import { AxiosError } from 'axios';
import { API_URL } from './apiDictionary';
import { RESTClient, RESTClientMock } from './client';
// Todo:  import { USE_API_MOCKS } from '../env';
import {
  fetchDXAVisitDataMock,
  fetchDXAWorkstationDataMock,
  getSyncWorkstationDataStatusMock,
  putWorkstationDataToVisitMock,
  syncWorkstationDataMock,
} from './mocks/DXAReadings';
import {
  DXAReading,
  DXAWorkstationDataDTO,
} from '@dynamika-shared/types/DXAReading';
import { WorkflowExecution } from '@dynamika-shared/types/executions';
const USE_API_MOCKS = !!localStorage.getItem('dxaMock');

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchDXAVisitData = async (
  clinicalTrialId: string,
  taskId: string
) => {
  if (USE_API_MOCKS) {
    fetchDXAVisitDataMock(clinicalTrialId, taskId);
  }

  try {
    const response = await api.get<DXAWorkstationDataDTO>(
      API_URL.DXAVisitData.replace(':taskId', taskId),
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    if (response.status === 204) {
      return null;
    }

    return response.data;
  } catch (error) {
    if ((error as AxiosError).response?.status === 404) {
      return null;
    }
    console.error('Error fetching fetchDXAReadings', error);
    throw error;
  }
};

export const fetchDXAWorkstationData = async (
  clinicalTrialId: string,
  taskId: string
) => {
  if (USE_API_MOCKS) {
    fetchDXAWorkstationDataMock(clinicalTrialId, taskId);
  }
  try {
    const response = await api.get<DXAWorkstationDataDTO[]>(
      API_URL.DXAWorkstationData.replace(':taskId', taskId),
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching fetchDXAWorkstationReadings', error);
    throw error;
  }
};

export const syncWorkstationReadings = async (
  clinicalTrialId: string,
  taskId: string
) => {
  if (USE_API_MOCKS) {
    syncWorkstationDataMock(clinicalTrialId, taskId);
  }
  try {
    const response = await api.post<string>(
      API_URL.DXASync.replace(':taskId', taskId),
      undefined,
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error sync dxa', error);
    throw error;
  }
};

export const putWorkstationDataToVisit = async (
  clinicalTrialId: string,
  taskId: string,
  data: DXAReading[]
) => {
  if (USE_API_MOCKS) {
    putWorkstationDataToVisitMock(clinicalTrialId, taskId, data);
  }
  try {
    const response = await api.put<string>(
      API_URL.DXAVisitData.replace(':taskId', taskId),
      data,
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error putWorkstationDataToVisit dxa', error);
    throw error;
  }
};

export const getSyncWorkstationReadingsStatus = async (
  clinicalTrialId: string,
  taskId: string
) => {
  // Registering a handler on the SHARED mock adapter unconditionally leaks into
  // every other module that uses the mock client — `onGet` appends and the first
  // match wins, so this could shadow another feature's handler for the same
  // generic /executions endpoint. Only register when DXA mocks are actually on.
  if (USE_API_MOCKS) {
    getSyncWorkstationDataStatusMock(clinicalTrialId, taskId);
  }
  try {
    const response = await api.get<WorkflowExecution[]>(
      API_URL.qcTaskExecutions.replace(':taskId', taskId),
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error DXA Sync status', error);
    throw error;
  }
};
